import { Component, OnInit } from '@angular/core';
import { CurrentDataService } from '../../../services/current-data-service';
import { Transporter } from '../../../models/transporter.model';

@Component({
  selector: 'jhi-legal-notices',
  templateUrl: './legal-notices.component.html',
})
export class LegalNoticesComponent implements OnInit {
  transporter: Transporter | undefined;

  constructor(protected currentDataService: CurrentDataService) {}

  ngOnInit(): void {
    this.currentDataService.getCurrentTransporter().subscribe(transporter => {
      this.transporter = transporter;
    });
  }
}
